import React, { Component } from 'react'
import confirmed from '../../assets/images/newui/sellersignup/confirmed.svg'
import billingInfo from '../../assets/images/newui/sellersignup/billing-info.svg'
import choosePlan from '../../assets/images/newui/sellersignup/choose-plan.svg'
import getStarted from '../../assets/images/newui/sellersignup/get-started.svg'
import confirmedActive from '../../assets/images/newui/sellersignup/confirmed-active.svg'
import billingInfoActive from '../../assets/images/newui/sellersignup/billing-info-active.svg'
import choosePlanActive from '../../assets/images/newui/sellersignup/choose-plan-active.svg'
import getStartedActive from '../../assets/images/newui/sellersignup/get-started-active.svg'
import backImg from '../../assets/images/newui/sellersignup/back-wizard.svg'
import './SignupWizard.less'

const tabs = [
    {
        position: 0,
        image: getStarted,
        imageActive: getStartedActive,
        content: "Let's Get Started"
    }, {
        position: 1,
        image: choosePlan,
        imageActive: choosePlanActive,
        content: "Choose Plan"
    }, {
        position: 2,
        image: billingInfo,
        imageActive: billingInfoActive,
        content: "Company Details"
    }, {
        position: 3,
        image: confirmed,
        imageActive: confirmedActive,
        content: "Confirmed"
    },

]

class SignupWizard extends Component {
    constructor(props) {
        super(props)
    }

    moveBack = (position) => {
        if (this.props.activeTabIndex > position) {
            this.props.moveBack();
        }
    }

    render() {
        const clonedTabs = tabs.filter(tab => tab.position >= this.props.activeTabIndex);
        if (this.props.activeTabIndex > 0) {
            clonedTabs.unshift(
                {
                    position: this.props.activeTabIndex - 1,
                    image: backImg,
                    inactiveContent: 'Back'
                }
            )
        }
        return <div className='signup-wizard-container'>
            {clonedTabs && clonedTabs.length > 0 && clonedTabs.map(tab => <>
                <div onClick={() => this.moveBack(tab.position)} className={`signup-wizard-tab${this.props.activeTabIndex == tab.position ? ' active' : ''}${tab.inactiveContent ? ' back' : ''}`}>
                    <div className={`tab-img${tab.inactiveContent ? ' back' : ''}`}> <img src={this.props.activeTabIndex == tab.position ? tab.imageActive : tab.image} /></div>
                    {this.props.activeTabIndex == tab.position ? <div className='tab-content'>{tab.content}</div> : ''}
                    {tab.inactiveContent ? <div className='tab-content inactive'>{tab.inactiveContent}</div> : ''}
                </div>
            </>)}
        </div>
    }
}

export default SignupWizard;